module.exports = __webpack_public_path__ + "img/specified-shipment.3fdc6d2e.svg";